<template>
    <div class="main-container">
        <NavBar/>
        <div class="page">
            <TitleBar @back="handleBackEvent">
                <slot name="titlebarSecondRow"></slot>
            </TitleBar>
            <div class="page-view">
                <slot></slot>
            </div>
            <ToolBar>
                <div slot="left">
                    <slot name="toolbarLeft"></slot>
                </div>
                <div slot="center">
                    <slot name="toolbarCenter"></slot>
                </div>
                <slot name="toolbar"></slot>
            </ToolBar>
        </div>

    </div>
</template>

<script>
    import NavBar from '@c/ui/Navbar'
    import TitleBar from '@c/ui/TitleBar';
    import ToolBar from '@c/ui/ToolBar';


    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {
            TitleBar,
            ToolBar,
            NavBar,

        },
        computed: {},
        created: function () {

        },
        data() {
            return {}
        },
        destroyed: function () {

        },
        methods: {
            handleBackEvent(){
                this.$emit('back');
            }
        },
        mounted: function () {

        },
        name: 'LayoutBase',
        props: {},
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/layouts/BaseWithToolbar.vue